import { SurveyResponse } from '@/types'
import { EnrollmentSurveyContent } from '../get-enrollment-survey-content'
import { match } from 'ts-pattern'

export default function massCleanPeakSurveyContent(
  surveyResponse: SurveyResponse,
) {
  const header =
    ((
      surveyResponse.survey?.metadata?.view_config as {
        review_application_header?: string
      }
    )?.review_application_header as string) ?? 'Smart Charger'
  const smartCharging = Boolean(
    surveyResponse.response?.smart_charging ?? false,
  )
  const chargerBrand = surveyResponse.response?.charger_brand ?? 'Unknown'
  const chargerModel = surveyResponse.response?.charger_model ?? 'Unknown'
  const rowItems = match(smartCharging)
    .with(true, () => [`Brand: ${chargerBrand}`, `Model: ${chargerModel}`])
    .with(false, () => ['No smart chargers'])
    .exhaustive()
  return {
    header,
    rowItems,
  } satisfies EnrollmentSurveyContent
}
